import { Frequency } from "./frequency";

export const FREQUENCIES: Frequency[] = [
    { id: 1, name: "often"},
    { id: 2, name: "sometimes"},
    { id: 3, name: "never"}
]